var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DatePicker',{ref:"inputDatePicker",attrs:{"placeholder":_vm.placeholder,"disabled":_vm.disabled,"range":_vm.range,"type":_vm.type,"lang":_vm.langPtBR,"format":_vm.format,"value-type":"timestamp"},model:{value:(_vm.timestamps),callback:function ($$v) {_vm.timestamps=$$v},expression:"timestamps"}})
}
var staticRenderFns = []

export { render, staticRenderFns }